import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'negativeNumberToPositive'
})

export class NegativeNumberToPositivePipe implements PipeTransform {

  transform(value: number): number {
    if(value<0) {
      return value*(-1);
    } else {
      return value;
    }
    
  }

}